// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let FormalityUI = require("../common/Form/FormalityUI.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let EditMarketingProfileMemberInfoFormMutation_graphql = require("../../__generated__/EditMarketingProfileMemberInfoFormMutation_graphql.bs.js");
let EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.bs.js");

let validators_title = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let title = param.title;
    if (title === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: title
      };
    }
  }
};

let validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let lastName = param.lastName;
    if (lastName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: lastName
      };
    }
  }
};

let validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let firstName = param.firstName;
    if (firstName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: firstName
      };
    }
  }
};

let validators = {
  bio: undefined,
  title: validators_title,
  licenseNumber: undefined,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(input) {
  return {
    bio: "Pristine",
    title: "Pristine",
    licenseNumber: "Pristine",
    lastName: "Pristine",
    firstName: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match_0 = {
    TAG: "Ok",
    _0: input.bio
  };
  let match = fieldsStatuses.title;
  let tmp;
  tmp = typeof match !== "object" ? validators.title.validate(input) : match._0;
  let match_0$1 = {
    TAG: "Ok",
    _0: input.licenseNumber
  };
  let match$1 = fieldsStatuses.lastName;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.lastName.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.firstName;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.firstName.validate(input) : match$2._0;
  let bioResult = match_0;
  let bioResult$1;
  if (bioResult.TAG === "Ok") {
    let titleResult = tmp;
    if (titleResult.TAG === "Ok") {
      let licenseNumberResult = match_0$1;
      if (licenseNumberResult.TAG === "Ok") {
        let lastNameResult = tmp$1;
        if (lastNameResult.TAG === "Ok") {
          let firstNameResult = tmp$2;
          if (firstNameResult.TAG === "Ok") {
            return {
              TAG: "Valid",
              output: {
                firstName: firstNameResult._0,
                lastName: lastNameResult._0,
                licenseNumber: licenseNumberResult._0,
                title: titleResult._0,
                bio: bioResult._0
              },
              fieldsStatuses: {
                bio: {
                  TAG: "Dirty",
                  _0: bioResult,
                  _1: "Hidden"
                },
                title: {
                  TAG: "Dirty",
                  _0: titleResult,
                  _1: "Shown"
                },
                licenseNumber: {
                  TAG: "Dirty",
                  _0: licenseNumberResult,
                  _1: "Hidden"
                },
                lastName: {
                  TAG: "Dirty",
                  _0: lastNameResult,
                  _1: "Shown"
                },
                firstName: {
                  TAG: "Dirty",
                  _0: firstNameResult,
                  _1: "Shown"
                }
              },
              collectionsStatuses: undefined
            };
          }
          bioResult$1 = bioResult;
        } else {
          bioResult$1 = bioResult;
        }
      } else {
        bioResult$1 = bioResult;
      }
    } else {
      bioResult$1 = bioResult;
    }
  } else {
    bioResult$1 = bioResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      bio: {
        TAG: "Dirty",
        _0: bioResult$1,
        _1: "Hidden"
      },
      title: {
        TAG: "Dirty",
        _0: tmp,
        _1: "Shown"
      },
      licenseNumber: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      },
      lastName: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      firstName: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurBioField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.bio, state.fieldsStatuses.bio, status => {
            let init = state.fieldsStatuses;
            return {
              bio: status,
              title: init.title,
              licenseNumber: init.licenseNumber,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTitleField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.title, validators_title, status => {
            let init = state.fieldsStatuses;
            return {
              bio: init.bio,
              title: status,
              licenseNumber: init.licenseNumber,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLicenseNumberField" :
          let result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.licenseNumber, state.fieldsStatuses.licenseNumber, status => {
            let init = state.fieldsStatuses;
            return {
              bio: init.bio,
              title: init.title,
              licenseNumber: status,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLastNameField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.lastName, validators_lastName, status => {
            let init = state.fieldsStatuses;
            return {
              bio: init.bio,
              title: init.title,
              licenseNumber: init.licenseNumber,
              lastName: status,
              firstName: init.firstName
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFirstNameField" :
          let result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.firstName, validators_firstName, status => {
            let init = state.fieldsStatuses;
            return {
              bio: init.bio,
              title: init.title,
              licenseNumber: init.licenseNumber,
              lastName: init.lastName,
              firstName: status
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateBioField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.bio, status => {
                let init = state.fieldsStatuses;
                return {
                  bio: status,
                  title: init.title,
                  licenseNumber: init.licenseNumber,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTitleField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.title, state.submissionStatus, validators_title, status => {
                let init = state.fieldsStatuses;
                return {
                  bio: init.bio,
                  title: status,
                  licenseNumber: init.licenseNumber,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLicenseNumberField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.licenseNumber, status => {
                let init = state.fieldsStatuses;
                return {
                  bio: init.bio,
                  title: init.title,
                  licenseNumber: status,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLastNameField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, status => {
                let init = state.fieldsStatuses;
                return {
                  bio: init.bio,
                  title: init.title,
                  licenseNumber: init.licenseNumber,
                  lastName: status,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFirstNameField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, status => {
                let init = state.fieldsStatuses;
                return {
                  bio: init.bio,
                  title: init.title,
                  licenseNumber: init.licenseNumber,
                  lastName: init.lastName,
                  firstName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateBio: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBioField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTitle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTitleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLicenseNumber: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLicenseNumberField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLastName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLastNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFirstName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFirstNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurBio: () => dispatch("BlurBioField"),
    blurTitle: () => dispatch("BlurTitleField"),
    blurLicenseNumber: () => dispatch("BlurLicenseNumberField"),
    blurLastName: () => dispatch("BlurLastNameField"),
    blurFirstName: () => dispatch("BlurFirstNameField"),
    bioResult: Formality.exposeFieldResult(state.fieldsStatuses.bio),
    titleResult: Formality.exposeFieldResult(state.fieldsStatuses.title),
    licenseNumberResult: Formality.exposeFieldResult(state.fieldsStatuses.licenseNumber),
    lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
    firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.bio;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.title;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.licenseNumber;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.lastName;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.firstName;
      return typeof tmp$4 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = EditMarketingProfileMemberInfoFormMutation_graphql.Internal.convertVariables;

let convertResponse = EditMarketingProfileMemberInfoFormMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = EditMarketingProfileMemberInfoFormMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, EditMarketingProfileMemberInfoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, EditMarketingProfileMemberInfoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function initialStateFromFragment(member) {
  return {
    firstName: member.firstName,
    lastName: member.lastName,
    licenseNumber: Stdlib_Option.getOr(member.licenseNumber, ""),
    title: member.title,
    bio: member.bio
  };
}

function messageToString(v) {
  return "is required";
}

function EditMarketingProfileMemberInfoForm$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
    messageToString: messageToString,
    result: props.result
  });
}

let FieldValidationMessage = {
  make: EditMarketingProfileMemberInfoForm$FieldValidationMessage
};

function EditMarketingProfileMemberInfoForm$InputField(props) {
  let status = props.status;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            type: props._type,
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
            value: props.value
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null),
          JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$FieldValidationMessage, {
            result: status
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: EditMarketingProfileMemberInfoForm$InputField
};

function EditMarketingProfileMemberInfoForm$BioField(props) {
  let form = props.form;
  let initialBio = React.useRef(form.input.bio);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: "Bio"
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(RichTextEditorV5.make, {
          initialContent: initialBio.current,
          onChange: value => form.updateBio((input, value) => ({
            firstName: input.firstName,
            lastName: input.lastName,
            licenseNumber: input.licenseNumber,
            title: input.title,
            bio: value
          }), value),
          onBlur: param => form.blurBio(),
          toolbar: "withoutHeaders"
        }),
        className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let BioField = {
  make: EditMarketingProfileMemberInfoForm$BioField
};

function EditMarketingProfileMemberInfoForm(props) {
  let member = RescriptRelay_Fragment.useFragment(EditMarketingProfileMemberInfoForm_marketingProfileMember_graphql.node, convertFragment, props.member);
  let match = use$1();
  let mutate = match[0];
  let form = useForm(initialStateFromFragment(member), (data, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    mutate({
      input: {
        bio: data.bio,
        firstName: data.firstName,
        lastName: data.lastName,
        licenseNumber: Form__Helpers.opt_of_string(data.licenseNumber),
        memberId: member.id,
        title: data.title
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateMarketingProfileMemberInfo;
      if (result !== undefined && result.__typename === "MarketingProfileMemberInfoUpdated") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure();
      }
    }, param => notifyOnFailure(), undefined);
  });
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let match$1 = form.status;
  let tmp;
  let exit = 0;
  if (typeof match$1 !== "object") {
    if (match$1 === "Editing") {
      tmp = null;
    } else {
      exit = 1;
    }
  } else if (match$1.TAG === "Submitting") {
    exit = 1;
  } else {
    tmp = JsxRuntime.jsx(Alert.$$Error.make, {
      title: `There was an error updating ` + member.firstName + `'s profile. Please try again`
    });
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Alert.Success.make, {
      title: member.firstName + `'s profile was updated`
    });
  }
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
            onChange: event => form.updateFirstName((input, value) => ({
              firstName: value,
              lastName: input.lastName,
              licenseNumber: input.licenseNumber,
              title: input.title,
              bio: input.bio
            }), event.target.value),
            onBlur: param => form.blurFirstName(),
            value: form.input.firstName,
            status: form.firstNameResult,
            labelText: "First name"
          }),
          JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
            onChange: event => form.updateLastName((input, value) => ({
              firstName: input.firstName,
              lastName: value,
              licenseNumber: input.licenseNumber,
              title: input.title,
              bio: input.bio
            }), event.target.value),
            onBlur: param => form.blurLastName(),
            value: form.input.lastName,
            status: form.lastNameResult,
            labelText: "Last name"
          }),
          JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
            onChange: event => form.updateTitle((input, value) => ({
              firstName: input.firstName,
              lastName: input.lastName,
              licenseNumber: input.licenseNumber,
              title: value,
              bio: input.bio
            }), event.target.value),
            onBlur: param => form.blurTitle(),
            value: form.input.title,
            status: form.titleResult,
            labelText: "Title"
          }),
          ReactRender.ifTrue(JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$InputField, {
            onChange: event => form.updateLicenseNumber((input, value) => ({
              firstName: input.firstName,
              lastName: input.lastName,
              licenseNumber: value,
              title: input.title,
              bio: input.bio
            }), event.target.value),
            onBlur: param => form.blurLicenseNumber(),
            value: form.input.licenseNumber,
            status: form.licenseNumberResult,
            labelText: "License number"
          }), hasFullProfile),
          ReactRender.ifTrue(JsxRuntime.jsx(EditMarketingProfileMemberInfoForm$BioField, {
            form: form
          }), hasFullProfile)
        ],
        className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            disabled: form.submitting,
            children: "Save changes"
          }),
          JsxRuntime.jsx("div", {
            children: tmp,
            role: "status"
          })
        ],
        className: "flex flex-col sm:flex-row gap-4 sm:items-center"
      })
    ],
    className: "space-y-8",
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let make = EditMarketingProfileMemberInfoForm;

exports.Config = Config;
exports.Fragment = Fragment;
exports.Mutation = Mutation;
exports.initialStateFromFragment = initialStateFromFragment;
exports.messageToString = messageToString;
exports.FieldValidationMessage = FieldValidationMessage;
exports.InputField = InputField;
exports.BioField = BioField;
exports.make = make;
/* commitMutation Not a pure module */
